module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/mplan0-38a858cdfe6cf47fe3c79bd83c17d898.jpg";